<textarea type="text-area" [disabled]="currentQuestion.NASelected" class="mt-2" [name]="currentQuestion.GUID" [(ngModel)]="currentValue" (keyup)="updateCurrentAnswer()" class="text-box mt-4" placeholder="Please respond here..."></textarea>
@if (currentQuestion.AllowNA) {
  <div class="mt-4 mx-2 flex items-center" >
    <app-simple-toggle class="mr-2" [(isChecked)]="currentQuestion.NASelected" (isCheckedChange)="validateAnswered()"></app-simple-toggle>
    <label (click)="updateNA()" class="hover:cursor-pointer">Not Applicable</label>
  </div>
}